import React, {useCallback} from 'react';
import {useParams, useSearchParams} from 'react-router';
import {AIAssistantChatPanel} from '../../../aiAssistantChat';
import {useReportStore} from '../../useReportStore';
import useSourcesFileViewerStore from '../../../../stores/useSourcesFileViewerStore';

const CHAT_CONVERSATION_ID_PARAM = 'chatConversationId';
const CHAT_DEBUG_PARAM = 'chatDebug';

const AIAssistantChatTab = ({isActive = false, onAction}) => {
    const {reportId} = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const productTypeValue = useReportStore((state) => state.productType?.value || 'report');
    const title = useReportStore((state) => state.title || 'this document');
    const focusRequestToken = useReportStore((state) => state.chatComposerFocusRequestToken);
    const setChatComposerFocused = useReportStore((state) => state.setChatComposerFocused);
    const isSourceFileViewerOpen = useSourcesFileViewerStore((state) => state.isOpen);
    const sourceFileName = useSourcesFileViewerStore((state) => state.fileName);
    const conversationId = searchParams.get(CHAT_CONVERSATION_ID_PARAM);
    const showDebug = searchParams.get(CHAT_DEBUG_PARAM) === '1';
    const emptyStatePreset = isSourceFileViewerOpen ? 'sourceFile' : 'report';
    const emptyStateDocumentTitle = isSourceFileViewerOpen
        ? (sourceFileName || 'this source file')
        : title;

    const handleConversationChange = useCallback((nextConversationId) => {
        setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            if (nextConversationId) {
                next.set(CHAT_CONVERSATION_ID_PARAM, nextConversationId);
            } else {
                next.delete(CHAT_CONVERSATION_ID_PARAM);
            }
            return next;
        }, {replace: true});
    }, [setSearchParams]);

    return (
        <AIAssistantChatPanel
            conversationId={conversationId}
            documentId={reportId || null}
            documentType={productTypeValue}
            documentTitle={title}
            emptyStateDocumentTitle={emptyStateDocumentTitle}
            emptyStatePreset={emptyStatePreset}
            focusRequestToken={focusRequestToken}
            showDebug={showDebug}
            isActive={isActive}
            onAction={onAction}
            onComposerFocusChange={setChatComposerFocused}
            onConversationChange={handleConversationChange}
        />
    );
};

export default AIAssistantChatTab;
